import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  profile: {
    color: 'gray'
  }
});


class Profile extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.profile}>
        <h2>Profile</h2>
      </div>
    );
  }
}

export default withStyles(styles)(Profile);


// WEBPACK FOOTER //
// ./src/components/Profile/index.js